<script>
    import { mapActions, mapMutations, mapState } from "vuex";
    import { sendAnalytics } from "@/core/SendAnalytics";
    import { myTarget } from "@/core/SendMyTarget";

    export default {
        name: "ButtonCompare",
        props: {
            size: String,
            productId: Number,
            isCloneProduct: Boolean,
        },
        data() {
            return {
                currentInComparison: false,
                isLoading: false,
            };
        },
        computed: {
            ...mapState("Compare", ["comparisonIdsList"]),
            textForProduct() {
                return this.currentInComparison
                    ? "Перейти к сравнению"
                    : "Добавить к сравнению";
            },
            textForTooltip() {
                return this.currentInComparison ? "Сравниваем" : "К сравнению";
            },
        },
        watch: {
            comparisonIdsList: {
                handler(updatedIdsList) {
                    this.checkComparisonState(updatedIdsList);
                },
            },
        },
        mounted() {
            this.checkComparisonState(this.comparisonIdsList);
        },
        methods: {
            ...mapActions("Compare", ["addToComparison", "removeFromComparison"]),
            ...mapMutations("Compare", {
                setComparison: "SET_COMPARISON_FOR_CLONE",
            }),
            checkComparisonState(comparisonIdsList) {
                let idsList = [];
                comparisonIdsList.forEach((obj) => {
                    idsList.push(obj.id);
                });
                this.currentInComparison = idsList.includes(this.productId);
            },
            addToComparisonHandler() {
                this.addToComparison(this.productId).then(() => {
                    this.isLoading = false;
                    this.currentInComparison = true;
                    sendAnalytics.send(sendAnalytics.events.compare);
                    myTarget.reachGoal("compare");
                    if (this.isCloneProduct) {
                        this.setComparison({ type: "add", id: this.productId });
                    }
                });
            },
            goToCompare() {
                this.isLoading = false;
                this.$router.push({ name: "Compare" });
            },
            toggleComparisonHandler() {
                this.isLoading = true;
                if (this.currentInComparison) {
                    this.goToCompare();
                } else {
                    this.addToComparisonHandler();
                }
            },
        },
    };
</script>

<template>
    <button
        class="button-compare outline"
        :class="{
            'is-loading': isLoading,
            'is-comparison': currentInComparison,
            'button-compare--md': size === 'md',
            'button-compare--lg': size === 'lg',
        }"
        @click="toggleComparisonHandler"
    >
        <span class="button-compare__line button-compare__line--1"></span>
        <span class="button-compare__line button-compare__line--2"></span>
        <span class="button-compare__line button-compare__line--3"></span>

        <span class="button-compare__tooltip">
            {{ textForTooltip }}
        </span>
        <span class="button-compare__text">
            {{ textForProduct }}
        </span>
    </button>
</template>

<style lang="scss">
    .button-compare {
        position: relative;
        display: flex;
        align-items: flex-end;
        justify-content: center;

        &:not(.is-comparison):hover {
            .button-compare__line {
                background-color: var(--secondary);
            }
        }

        &.is-comparison {
            .button-compare__line {
                background-color: var(--primary);
            }

            .button-compare__tooltip {
                color: var(--primary);
            }
        }

        @include bp($bp-mobile-md) {
            &:hover,
            &:focus {
                .button-compare__tooltip {
                    transform: translateX(0);
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }

    .button-compare__tooltip {
        position: absolute;
        right: 34px;
        bottom: 0;
        font-size: 14px;
        white-space: nowrap;
        color: var(--secondary);
        transform: translateX(5px);
        opacity: 0;
        visibility: hidden;
        transition: 0.4s ease-out all;
    }

    .button-compare__line {
        background-color: var(--secondary);
        transition: 0.3s ease-in-out all;
    }

    .button-compare--md {
        position: relative;

        &:after {
            content: "";
            @include center-absolute(0);
            margin: auto;
            margin: -10px;
        }

        @include box(24px);

        @include bp($bp-desktop-sm) {
            @include box(32px);
        }

        .button-compare__line--1 {
            height: 11px;
        }

        .button-compare__line--2 {
            height: 6px;
        }

        .button-compare__line--3 {
            height: 18px;
        }

        &:not(.is-comparison):hover {
            .button-compare__line--1 {
                height: 18px;
            }

            .button-compare__line--2 {
                height: 8px;
            }

            .button-compare__line--3 {
                height: 12px;
            }
        }

        .button-compare__line {
            width: 2px;
            margin: 0 2px;
        }
    }

    .button-compare__text {
        display: none;
        font-weight: bold;
        font-size: 14px;
        line-height: 26px;
        color: var(--secondary);
        margin-left: 8px;
        height: 22px;
    }

    .button-compare--lg {
        margin-top: 16px;

        @include bp($bp-desktop-sm) {
            margin-top: 0;
        }

        .button-compare__line {
            width: 2px;
            margin: 0 2px;
        }

        .button-compare__line--1 {
            height: 11px;
        }

        .button-compare__line--2 {
            height: 6px;
        }

        .button-compare__line--3 {
            height: 18px;
        }

        .button-compare__tooltip {
            display: none;
        }

        .button-compare__text {
            display: block;
        }

        &.is-comparison {
            .button-compare__line {
                background-color: var(--primary--dark);
            }
            .button-compare__text {
                color: var(--primary--dark);
            }
        }

        &:not(.is-comparison):hover {
            .button-compare__line--1 {
                height: 18px;
            }

            .button-compare__line--2 {
                height: 8px;
            }

            .button-compare__line--3 {
                height: 12px;
            }
        }
    }
</style>
